<template>
  <div>
    <h3>Face Feature Extraction - Frontend Only</h3>
    
    <!-- Webcam Video -->
    <video 
      ref="videoRef" 
      autoplay 
      muted 
      width="500" 
      height="400"
      style="border: 2px solid #ccc; background-color: #000;"
    ></video>
    
    <!-- Canvas for drawing detections -->
    <canvas 
      ref="canvasRef" 
      style="display: none;"
    ></canvas>
    
    <div>
      <button @click="extractFeatures" :disabled="!modelsLoaded">
        Extract Face Features
      </button>
      <button @click="clearFeatures" :disabled="!extractedFeatures">
        Clear
      </button>
    </div>
    
    <div>
      <h4>Status: {{ statusMessage }}</h4>
      <div v-if="extractedFeatures">
        <h4>✅ Face Features Extracted!</h4>
        <p>Feature vector length: {{ extractedFeatures.length }} numbers</p>
        <details>
          <summary>View first 20 values</summary>
          <pre>{{ extractedFeatures.slice(0, 20) }}</pre>
        </details>
      </div>
    </div>
  </div>
</template>

<script>
/* global faceapi */

export default {
  name: "App",
  props:['baseUrl'],
  data() {
    return {
      modelsLoaded: false,
      extractedFeatures: null,
      statusMessage: 'Loading face detection models...',
      stream: null
    }
  },
  async mounted() {
    // Check if faceapi is available
    if (typeof faceapi === 'undefined') {
      this.statusMessage = 'Error: face-api.js not loaded. Please check CDN.';
      console.error('faceapi is not defined');
      return;
    }
    
    await this.loadModels();
    await this.startWebcam();
  },
  beforeUnmount() {
    // Stop webcam when component is destroyed
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
    }
  },
  methods: {
    async loadModels() {
      const MODEL_URL = '/models';
      
      try {
        this.statusMessage = 'Loading models...';
        
        await faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL);
        await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);
        await faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL);
        
        this.modelsLoaded = true;
        this.statusMessage = '✅ Models ready! Click "Extract Face Features"';
        console.log('Models loaded successfully');
      } catch (error) {
        console.error('Failed to load models:', error);
        this.statusMessage = 'Error loading models. Make sure model files are in /public/models/';
      }
    },
    
    async startWebcam() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ 
          video: { 
            width: { ideal: 640 },
            height: { ideal: 480 }
          } 
        });
        
        if (this.$refs.videoRef) {
          this.$refs.videoRef.srcObject = this.stream;
          await this.$refs.videoRef.play();
          console.log('Webcam started');
        }
      } catch (error) {
        console.error('Webcam error:', error);
        this.statusMessage = 'Could not access webcam. Please check permissions.';
      }
    },
    
    async extractFeatures() {
      if (!this.modelsLoaded) {
        this.statusMessage = 'Models not loaded yet';
        return;
      }
      
      const video = this.$refs.videoRef;
      if (!video.videoWidth) {
        this.statusMessage = 'Camera not ready. Please wait.';
        return;
      }
      
      this.statusMessage = 'Detecting face and extracting features...';
      
      try {
        // Detect face and get descriptor (feature vector)
        const detection = await faceapi
          .detectSingleFace(video)
          .withFaceLandmarks()
          .withFaceDescriptor();
        
        if (!detection) {
          this.statusMessage = '❌ No face detected. Please look at camera.';
          this.extractedFeatures = null;
          return;
        }
        
        // Draw detection on canvas for visual feedback
        const canvas = this.$refs.canvasRef;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const displaySize = { width: video.videoWidth, height: video.videoHeight };
        faceapi.matchDimensions(canvas, displaySize);
        const resizedDetection = faceapi.resizeResults(detection, displaySize);
        faceapi.draw.drawDetections(canvas, [resizedDetection]);
        
        // Convert descriptor to regular array
        this.extractedFeatures = Array.from(detection.descriptor);
        
        this.statusMessage = '✅ Face features extracted successfully!';
        console.log('Feature vector:', this.extractedFeatures);
        
      } catch (error) {
        console.error('Extraction error:', error);
        this.statusMessage = 'Error during face extraction.';
      }

        let addOfficerRequestUrl = this.baseUrl + "SecurityOfficers/SaveFacialFeature";
let addOfficerrequestOptions = {
    method: "POST",
    headers: {
        "Authorization": `Bearer ${localStorage.Guardtoken}`,
        "Content-Type": "application/json"
    },
    body: JSON.stringify({
        FacialFeatures: this.extractedFeatures
    })
};

fetch(addOfficerRequestUrl, addOfficerrequestOptions)
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            alert("message = " + data.message);
        } else {
            alert("Update Officer Failed.");
        }
    })
    .catch(error => {
        alert("Error: " + error);
    });


    },
    
    clearFeatures() {
      this.extractedFeatures = null;
      this.statusMessage = 'Features cleared. Ready for new extraction.';
      
      // Clear canvas
      const canvas = this.$refs.canvasRef;
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
    }
  }
}
</script>

<style scoped>
button {
  margin: 10px;
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

video {
  margin: 10px;
  border-radius: 8px;
}

pre {
  background: #f4f4f4;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 12px;
}
</style>